import Stickyfill from '../helpers/stickyfill.js';

function init() {
  const stickyBlock = document.querySelectorAll('.view-basket-summary-container--sticky');

  if (stickyBlock) {
    Stickyfill.add(stickyBlock);
  }
}

if ('querySelector' in document) {
  init();
}
